import type {NotificationEvent} from '../../api/event';

export const findContext = <T>(event: NotificationEvent, contextType: string) =>
  event.contexts.find(
    item => item && item._id.split(':')[0] === contextType,
  ) as T | undefined;
